// extracted by mini-css-extract-plugin
export default {"root":"StuViewModal_root__vLVMS"};